import React from 'react'
import RequestServies from '../../services/RequestServices'
import NotificationServices from '../../services/NotificationServices';
import HomesliderServices from '../../services/HomeSliderServices';
import WebsliderServices from '../../services/WebSliderServices.js';
import AdminServices from '../../services/AdminServices';
import FeedbackServices from '../../services/FeedbackServices';

import UserServices from '../../services/UserServices.js';
import PlanServices from '../../services/PlanServices.js';
import BookingServices from '../../services/BookingServices.js';
import CategoryServices from '../../services/CategoryServices.js';
import SubCategoryServices from '../../services/SubCategoryServices.js';
import BrandServices from '../../services/BrandServices.js';
import VehicleServices from '../../services/VehicleServices.js';
import CarServices from '../../services/CarServices.js';
import AddonsServices from '../../services/AddonsServices.js';
import CoupanServices from '../../services/CoupanServices.js';
import PurchaseServices from '../../services/PurchaseServices.js';
import LocationServices from '../../services/LocationServices.js';
import TimeSlotServices from '../../services/TimeSlotServices.js';
import HappyCustomerServices from '../../services/HappyCustomerServices.js';
import OrderAndDealsServices from '../../services/Order&DealServices.js';


function DeleteButton({data,page,closeModal,onSuccess}) {


  const handleDelete = async () => {
 if (page === 'Help') {

    const res = await RequestServies.deleteHelp(data._id);

    if(res.status === true){
      alert('deleted successfully');
      closeModal();
      onSuccess();
    } 
    else {
      console.log(res)
    }
  }
  else if (page === 'User') {

    const res = await UserServices.deleteUser(data._id);

    if(res.status === true){
      alert('deleted successfully');
      closeModal();
      onSuccess();
    } 
    else {
      console.log(res)
    }
  }
  else if (page === 'happy') {

    const res = await HappyCustomerServices.deleteHappy(data._id);

    if(res.status === true){
      alert('deleted successfully');
      closeModal();
      onSuccess();
    } 
    else {
      console.log(res)
    }
  }
  else if (page === 'order-deal') {

    const res = await OrderAndDealsServices.deleteOrderAndDeals(data._id);

    if(res.status === true){
      alert('deleted successfully');
      closeModal();
      onSuccess();
    } 
    else {
      console.log(res)
    }
  }
  else if (page === 'Addons') {

    const res = await AddonsServices.deleteAddons(data._id);

    if(res.status === true){
      alert('deleted successfully');
      closeModal();
      onSuccess();
    } 
    else {
      console.log(res)
    }
  }
  else if (page === 'Coupan') {

    const res = await CoupanServices.deleteCoupan(data._id);

    if(res.status === true){
      alert('deleted successfully');
      closeModal();
      onSuccess();
    } 
    else {
      console.log(res)
    }
  }

  else if (page === 'Purchase') {

    const res = await PurchaseServices.deletePurchases(data._id);

    if(res.status === true){
      alert('deleted successfully');
      closeModal();
      onSuccess();
    } 
    else {
      console.log(res)
    }
  }

  
  else if (page === 'Location') {

    const res = await LocationServices.deleteLocation(data._id);

    if(res.status === true){
      alert('deleted successfully');
      closeModal();
      onSuccess();
    } 
    else {
      console.log(res)
    }
  }
  else if (page === 'timeslots') {

    const res = await TimeSlotServices.deleteTime(data._id);

    if(res.status === true){
      alert('deleted successfully');
      closeModal();
      onSuccess();
    } 
    else {
      console.log(res)
    }
  }
  else if (page === 'Brand') {

    const res = await BrandServices.deleteBrand(data._id);

    if(res.status === true){
      alert('deleted successfully');
      closeModal();
      onSuccess();
    } 
    else {
      console.log(res)
    }
  }
  else if (page === 'Vehicle') {

    const res = await VehicleServices.deleteVehicle(data._id);

    if(res.status === true){
      alert('deleted successfully');
      closeModal();
      onSuccess();
    } 
    else {
      console.log(res)
    }
  }
  else if (page === 'Service') {

    const res = await CarServices.deleteService(data._id);

    if(res.status === true){
      alert('deleted successfully');
      closeModal();
      onSuccess();
    } 
    else {
      console.log(res)
    }
  }
  else if (page === 'Order') {

    const res = await BookingServices.deleteBooking(data._id);

    if(res.status === true){
      alert('deleted successfully');
      closeModal();
      onSuccess();
    } 
    else {
      console.log(res)
    }
  }
  else if (page === 'Category') {

    const res = await CategoryServices.deleteCategory(data._id);

    if(res.status === true){
      alert('deleted successfully');
      closeModal();
      onSuccess();
    } 
    else {
      console.log(res)
    }
  }
  else if (page === 'SubCategory') {

    const res = await SubCategoryServices.deleteSubCategory(data._id);

    if(res.status === true){
      alert('deleted successfully');
      closeModal();
      onSuccess();
    } 
    else {
      console.log(res)
    }
  }
  else if (page === 'Vendor') {

    const res = await UserServices.deleteVendor(data._id);

    if(res.status === true){
      alert('deleted successfully');
      closeModal();
      onSuccess();
    } 
    else {
      console.log(res)
    }
  }
  else if (page === 'plan') {

    const res = await PlanServices.deletePlan(data._id);

    if(res.status === true){
      alert('deleted successfully');
      closeModal();
      onSuccess();
    } 
    else {
      console.log(res)
    }
  }

  else if (page === 'feedback') {

    const res = await FeedbackServices.deleteFeedback(data._id);

    if(res.status === true){
      alert('deleted successfully');
      closeModal();
      onSuccess();
    } 
    else {
      console.log(res)
    }
  }else if (page === 'Add') {

    const res = await RequestServies.deleteAdevertis(data._id);

    if(res.status === true){
      alert('deleted successfully');
      closeModal();
      onSuccess();
    } 
    else {
      console.log(res)
    }
  }else if (page === 'HomeSlider') {

    const res = await HomesliderServices.deleteHomeSlider(data._id);

    if(res.status === true){
      alert('deleted successfully');
      closeModal();
      onSuccess();
    } 
    else {
      console.log(res)
    }
  }else if (page === 'WebSlider') {

    const res = await WebsliderServices.deleteWebSlider(data._id);

    if(res.status === true){
      alert('deleted successfully');
      closeModal();
      onSuccess();
    } 
    else {
      console.log(res)
    }
  }
  else if (page === 'notification') {

    const res = await NotificationServices.deleteNotification(data._id);

    if(res.status === true){
      alert('deleted successfully');
      closeModal();
      onSuccess();
    } 
    else {
      console.log(res)
    }
    
  }
  else if (page === 'pushnotification') {

    const res = await NotificationServices.deletePushNotification(data._id);

    if(res.status === true){
      alert('deleted successfully');
      closeModal();
      onSuccess();
    } 
    else {
      console.log(res)
    }
    
  }
  else if (page === 'Admin') {

    const res = await AdminServices.deleteAdmin(data._id);

    if(res.status === true){
      alert('deleted successfully');
      closeModal();
      onSuccess();
    } 
    else {
      console.log(res)
    }
  }
 
  else if (page === 'Banner') {

    const res = await HomesliderServices.deleteBanner(data._id);

    if(res.status === true){
      alert('deleted successfully');
      closeModal();
      onSuccess();
    } 
    else {
      console.log(res)
    }
  }
  }


  return (
    <div className="modal fade show d-block" id="deleteACModel" tabIndex="-1" aria-labelledby="deleteACModelLabel" aria-hidden="true">
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content modal-bg-light-green">
          <div className="modal-body py-4 px-5 text-center">
              <h4>Warning !!</h4>
              <p className="desc my-2">Are you sure you want to delete This Detail ?</p>
              <div className="donate-btn-grp text-center py-4">
                  <button className="site-btn btn-blue delete-btn" onClick={closeModal}>Cancel</button>
                  <button className="site-btn btn-red delete-btn" onClick={handleDelete}>Delete </button>
              </div>
          </div>
      </div>
    </div>
  </div>
  )
}

export default DeleteButton